import React, { useCallback } from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { AddButton, SearchInput, useAction, useHelmet, useHistoryPush } from '@agro-club/frontend-shared'
import SeedCropList from './SeedCropList/SeedCropList'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Routes from './routes'
import SeedCropActions from 'modules/domain/seedCrop/duck'
import SeedCropSelectors from 'modules/domain/seedCrop/selectors'
import { useSelector } from 'react-redux'
import AuthSelectors from 'modules/domain/auth/selectors'

const SearchInputWrapper = styled.div`
  padding: 18px 24px;
  width: 50%;
`

const SeedCropTable = () => {
  const push = useHistoryPush()
  const filter = useSelector(SeedCropSelectors.filter)
  const filterUpdated = useAction(SeedCropActions.filterUpdated)
  const { t } = useTranslation(['seedCrop'])
  const isAdmin = useSelector(AuthSelectors.isAdmin)

  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  const metaTitle = t('seedCropsMetaTitle')

  useHelmet({ title: metaTitle })

  return (
    <>
      <Layout.Header>
        <Header.TabsRoot>
          <Header.Tab title={t('list.heading')} isActive onClick={() => push({ route: Routes.List })}>
            {isAdmin && <AddButton to={Routes.Add} />}
          </Header.Tab>
        </Header.TabsRoot>
        <SearchInputWrapper>
          <SearchInput onChange={handleSearchChange} value={filter.search} placeholder={t('list.searchPlaceholder')} />
        </SearchInputWrapper>
      </Layout.Header>
      <Layout.Content>
        <SeedCropList />
      </Layout.Content>
    </>
  )
}

export default SeedCropTable
